import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

import VuetifyConfirm from "vuetify-confirm";
Vue.use(VuetifyConfirm, { vuetify });

import "./firebase";
import firebase from "firebase";

import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);

Vue.component("apexchart", VueApexCharts);

import VueGoogleCharts from "vue-google-charts";
Vue.use(VueGoogleCharts);

Vue.use(require("vue-moment"));

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  async created() {
    await firebase.auth().onAuthStateChanged((user) => {
      // console.log(user)
      store.dispatch("fetchUser", user.uid);
      store.dispatch("fetchPreferences");
    });
  },
  render: (h) => h(App),
}).$mount("#app");
